import React from "react";
import type { TFunction } from "i18next";
import { ResourceEnum } from "src/constants/constants.ts";
import type { Module } from "src/system/module.types.ts";
import type { RoleResource } from "@exonn/js-sdk";

export const module: Module<RoleResource> = {
  id: ResourceEnum.Role,
  smallIcon: <i className={"icon-15-rights_profiles"} />,
  name: (t: TFunction) => t("moduleName.roles"),
  bigIcon: <i className={"icon-20-rights_profiles"} />,

  tabs: {
    edit: {
      getTitle: (resource) => resource.name,
    },
  },
};
